export const itemReportQuantity = (value) => {
  const quantity = Number(value || 0);
  return Number.isFinite(quantity) ? Number(quantity.toFixed(2)) : 0;
};

export const formatItemReportQuantity = (value) => itemReportQuantity(value).toLocaleString('en-GB', {
  maximumFractionDigits: 2,
});
